// recipes-index.js
// Index léger des recettes (titre, lien, image, extrait, ingrédient principal) servi par templates/blog.ingredients.liquid.
// Préchargé sur la home (data-preload), réutilisé sur le blog via window.RecipesIndex.get().
// Balise : <script src="recipes-index.js" defer data-url="{{ blogs.recette.url }}" [data-preload]>

(() => {
  if (window.RecipesIndex) return;

  const script = document.currentScript;
  const url = script.dataset.url; // déjà localisé par Liquid (/fr/blogs/recette, /blogs/recette…)
  const KEY = `leparfait_recipes_index_v1:${url}`;
  const TTL = 6 * 60 * 60 * 1000;
  let pending = null;

  // Nettoie l'ancien cache (HTML complet des cartes) de predictive-recipe-search.js
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('leparfait_recipe_cards_cache_v1'))
      .forEach((k) => localStorage.removeItem(k));
  } catch (e) {}

  const fetchPage = (n) =>
    fetch(`${url}?view=ingredients&page=${n}`).then((r) => {
      if (!r.ok) throw new Error(`recipes-index page ${n}: ${r.status}`);
      return r.json();
    });

  async function load() {
    const first = await fetchPage(1);
    const rest = await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => fetchPage(i + 2)));
    return [first, ...rest].flatMap((p) => p.items);
  }

  window.RecipesIndex = {
    url,
    get() {
      if (pending) return pending;
      try {
        const cached = JSON.parse(localStorage.getItem(KEY));
        if (cached && Date.now() - cached.t < TTL) return (pending = Promise.resolve(cached.items));
      } catch (e) {}
      pending = load().then((items) => {
        try {
          localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items }));
        } catch (e) {}
        return items;
      });
      pending.catch(() => (pending = null));
      return pending;
    }
  };

  if (script.hasAttribute('data-preload')) {
    (window.requestIdleCallback || setTimeout)(() => window.RecipesIndex.get().catch(() => {}));
  }
})();
